export default __webpack_public_path__ + "static/media/am.6291e287.svg";